import React from 'react';

const ConstructionStatus = ({ rowData }) => {
    return (
        <span>
            {rowData.construction_status === "o" ?
                "اختصاص پیمانکار" :
            rowData.construction_status === "u" ?
                "در حال ساخت" :
            rowData.construction_status === "q" ?
                "کنترل کیفیت" :
            rowData.construction_status === "a" ?
                "در انتظار تسویه" :
            rowData.construction_status === "c" &&
                "تکمیل شده"
            }
        </span>
    );
}

export default ConstructionStatus;